import * as React from "react";
import { Datagrid, ExportButton, TextField, TopToolbar } from "react-admin";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { CustomDateField } from "../../../Components/CustomDateField";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const CockpitRequestedPnUnsvcPnDifferenceViewList = props => {
  const ListActions = props => (
    <TopToolbar {...props}>
      <ExportButton {...props} maxResults={99999} />
    </TopToolbar>
  );

  const exporter = records => {
    const data = records.map(record => ({
      RefNo: record.refNo,
      Customer: record.customer,
      "Requested Pn": record.requestedPn,
      "Core Pn": record.unsvcPn,
      "Created Date": record.createdDate,
    }));

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "Requested Pn & Core Pn Difference List");
  };

  return (
    <PoolList
      {...props}
      filterDefaultValues={props.filterParams}
      perPage={10}
      actions={<ListActions />}
      exporter={exporter}
      bulkActionButtons={false}
      filter={{ isDifferent: true }}
    >
      <Datagrid>
        <TextField source="refNo" label={"Ref No"}/>
        <TextField source="customer" label={"Customer"}/>
        <TextField source="requestedPn" label={"Requested Pn"}/>
        <TextField source="unsvcPn" label={"Core PN"}/>
        <CustomDateField source="createdDate" label={"Created Date"}/>
      </Datagrid>
    </PoolList>
  );
};

export default CockpitRequestedPnUnsvcPnDifferenceViewList;
